// export const domain = "http://127.0.0.1:8000/api";
// export const url = "http://127.0.0.1:8000";
//
export const domain = "https://tcdc-service.kisrasprint.com/api";
export const url = "https://tcdc-service.kisrasprint.com";
